import React from 'react';
import { AlertCircle, User, MessageSquare, Calendar, Tag } from 'lucide-react';
import { formatearFechaCompleta } from '../../../../utils/utils'; // Asegúrate de que la ruta sea correcta

const ModuloErrores = ({ errores = [] }) => {
  
  if (!errores || errores.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-10 bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200">
        <AlertCircle className="text-gray-400 mb-2" size={40} />
        <p className="text-gray-500 font-medium">No hay errores reportados en esta solicitud.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <AlertCircle className="text-red-500" size={20} />
          Historial de Reportes ({errores.length})
        </h3>
      </div>

      <div className="grid gap-4">
        {errores.map((error, index) => (
          <div 
            key={index} 
            className="bg-white border-l-4 border-red-500 shadow-sm rounded-r-xl border border-gray-200 overflow-hidden"
          >
            <div className="p-4">
              {/* Header del error: Categoría y Fecha */}
              <div className="flex flex-wrap justify-between items-start gap-2 mb-3">
                <div className="flex items-center gap-2 bg-red-50 text-red-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
                  <Tag size={12} />
                  {error.categoria || 'Error General'}
                </div>
                <div className="flex items-center gap-1 text-gray-400 text-xs">
                  <Calendar size={12} />
                  {error.fechaReporte ? formatearFechaCompleta(error.fechaReporte) : 'Fecha no registrada'}
                </div>
              </div>

              {/* Contenido: Comentario */}
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 mb-3">
                <div className="flex gap-2">
                  <MessageSquare size={16} className="text-gray-400 flex-shrink-0 mt-1" />
                  <p className="text-gray-700 text-sm italic">
                    "{error.comentario || 'Sin comentarios adicionales.'}"
                  </p>
                </div>
              </div>

              {/* Footer: Quién reportó */}
              <div className="flex items-center justify-end gap-2 text-xs text-gray-500">
                <span className="font-medium">Reportado por:</span>
                <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded-md">
                  <User size={12} />
                  <span className="font-bold text-gray-700">{error.nameTutor || 'Tutor Anónimo'}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="p-4 bg-blue-50 rounded-xl border border-blue-100 flex gap-3 items-start">
        <AlertCircle size={18} className="text-blue-500 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-blue-700">
          <strong>Nota para Administración:</strong> Estos reportes son generados por los tutores cuando detectan inconsistencias. Favor verificar los archivos y la descripción antes de asignar.
        </p>
      </div>
    </div>
  );
};

export default ModuloErrores;